<button type="button" mat-mini-fab color="primary" (click)="voltarPaginaAnterior()" matTooltip="Voltar">
    <mat-icon>west</mat-icon>
</button>
